import { FORM_ITEM_TYPE } from "../../../configuration/components/index";
import _, { filter, mixin } from 'lodash'
import Vue from 'vue'
export const mockFormData = [
    {
        type: FORM_ITEM_TYPE.WkTitle,
        payload: {
            field: _.uniqueId('title_'),
            props: {
                title: '账户&产品',
            }
        }
    },
    {
        type: 'WkRemoteSelect',  //
        payload: {
            label: "账户",    // 表单项的标题
            value: "",         // 表单项的值  1009742  账户 1557137109310036736 产品失败  账户1381945476990907008 产品成功 1336840310470225536
            field: "account_id",   // 表单项的唯一标识 提交
            rules: [{ required: true, message: "请选择账户", trigger: "change" }], // 表单项的验证规则
            props: {
                initial: 'run',  // 表单项的初始值 是run 初始化自动运行 否则不运行 只涉及远程搜索
                isBatch: false,
                isSearch: false,
                fetch_type: 'get',  // 接口类型，可选 'get' | 'post'，默认为 'get'
                fetch_url: '/batch/account/list?plat_id=10',  // 接口函数
                params: [],  // 接口参数  待定
                placeholder: "请选择要创建广告的目标账户", // 表单项的提示
                clearable: true, // 表单项的清除按钮
                style: "width: 600px", // 表单项的样式
            },
            fetchDependencies: [],  // 远程的关联字段  远程搜索
            dependencies: [],  // 依赖项 
            effects: []
        },

    },
    {
        type: 'WkRadioGroup',  //'input' | 'select' | 'checkbox' | 'radio' | 'WordsInput' | 'WkSelect' | 'WkRadioGroup' | 'WkCheckBoxGroup' | 'DynamicDate'| | 'WkTitle' | 'RadioDesc';
        payload: {
            label: "推广产品",    // 表单项的标题
            value: 'ANDROID_APP',         // 表单项的值
            field: "product_type",   // 表单项的唯一标识 提交
            rules: [{ required: true, message: "请选择投放范围", trigger: "change" }], // 表单项的验证规则
            props: {
                radioType: 'radio',
                defaultData: [
                    // {
                    //     "label": "网页",
                    //     "value": "WEB"
                    // },
                    {

                        "label": "应用",
                        "value": "ANDROID_APP"
                    },
                    {
                        "label": "快应用",
                        "value": "QUICK_APP"
                    },
                    // {
                    //     "label": "促销活动",
                    //     "value": "PROMOTION"
                    // },
                    // {
                    //     "label": "微信小程序",
                    //     "value": "MINI_APP"
                    // }
                ],
            },
            berforeChange: ({ target, oldValue }) => {  // 表单项的值改变前的回调函数  待定
                return new Promise((resolve, reject) => {
                    target.$confirm('此操作将清空投放产品和版位, 是否继续', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        resolve()
                    }).catch(() => {
                        reject()
                    });
                })
            },
            onChange: ({ target, oldValue }) => {  // 表单项的值改变后的回调函数  待定
                console.log(target, oldValue, '-------------------');
                let formItemComp = target.$refs.FormItemComp;
                while(formItemComp && formItemComp.formState.payload.field !== 'creative_size_id') {
                    formItemComp = formItemComp.$refs.FormItemComp;
                }
                if (formItemComp) {
                    formItemComp.formState.payload.value = [];
                }
               /**
                *  target.formState.payload.value = [];
                            const product_type = target.rootFormData.product_type;
                            const list = target.formState.payload.props.defaultData;
                            target.formState.payload.props.defaultData = list.map(v=> {
                                v.disabled = !v.config?.support_product_type?.includes(product_type);
                                return v;
                            });
                */
            }
        },
    },
    // {
    //     type: FORM_ITEM_TYPE.WkRadioGroup,  //'input' | 'select' | 'checkbox' | 'radio' | 'WordsInput' | 'WkSelect' | 'WkRadioGroup' | 'WkCheckBoxGroup' | 'DynamicDate'| | 'WkTitle' | 'RadioDesc';
    //     payload: {
    //         label: "上架状态",    // 表单项的标题
    //         value: '1',         // 表单项的值
    //         field: "reserve_status",   // 表单项的唯一标识 提交
    //         rules: [{ required: true, message: "请选择上架状态", trigger: "change" }], // 表单项的验证规则
    //         props: {
    //             defaultData: [
    //                 {
    //                     "label": "非预约",
    //                     "value": "1"
    //                 },
    //                 {
    //                     "label": "预约",
    //                     "value": "2"
    //                 }
    //             ],
    //         },
    //         dependencies: ['product_type'],  // 依赖项 
    //         effects: [
    //             {
    //                 condition: {
    //                     type: 'expression',
    //                     expression: 'values.product_type == "QUICK_APP"'
    //                 },
    //                 action: {
    //                     type: 'function',
    //                     value: (target) => {
    //                         Vue.set(target.formState.payload, 'value', '1');
    //                         Vue.set(target.formState.payload.props, 'defaultData', [{
    //                             "label": "非预约",
    //                             "value": "1"
    //                         }, {
    //                             "label": "预约",
    //                             "value": "2",
    //                             "disabled": true
    //                         }]);
    //                     }
    //                 }
    //             },
    //             {
    //                 condition: {
    //                     type: 'expression',
    //                     expression: 'values.product_type != "QUICK_APP"'
    //                 },
    //                 action: {
    //                     type: 'function',
    //                     value: (target) => {
    //                         Vue.set(target.formState.payload.props, 'defaultData', [{
    //                             "label": "非预约",
    //                             "value": "1"
    //                         }, {
    //                             "label": "预约",
    //                             "value": "2",
    //                         }]);
    //                     }
    //                 }
    //             }
    //         ]

    //     },
    // },
    {
        type: 'AdsRemoteSelect',  //
        payload: {
            label: "产品",    // 表单项的标题
            value: [],         // 表单项的值
            field: "app_id",   // 表单项的唯一标识 提交
            rules: [{ required: true, message: "请选择产品", trigger: "change" }], // 表单项的验证规则
            props: {
                isBatch: true,
                fetch_type: 'get',  // 接口类型，可选 'get' | 'post'，默认为 'get'
                fetch_url: '/batch/account/list?plat_id=10',  // 接口函数
                params: ['account_id', 'product_type', 'reserve_status'],  // 接口参数  待定
                placeholder: "请选择要投放的产品，可多选", // 表单项的提示
                clearable: true, // 表单项的清除按钮
                multiple: true, // 表单项的多选
                style: "width: 600px", // 表单项的样式
            }
        },
    },
    {
        type: FORM_ITEM_TYPE.WkTitle,
        payload: {
            field: _.uniqueId('title_'),
            props: {
                title: '计划',
            }
        }
    },
    {
        type: FORM_ITEM_TYPE.WkRadioGroup,  //'input' | 'select' | 'checkbox' | 'radio' | 'WordsInput' | 'WkSelect' | 'WkRadioGroup' | 'WkCheckBoxGroup' | 'DynamicDate'| | 'WkTitle' | 'RadioDesc';
        payload: {
            label: "计划类型",    // 表单项的标题
            value: "CAMPAIGN_TYPE_DISPLAY",         // 表单项的值
            // value_type: 'array', // 表单项的值类型，可选 'string' | 'number' | 'boolean' | 'array'，默认为 'string'
            field: "campaign_type",   // 表单项的唯一标识 提交
            rules: [{ required: true, message: "请选择投放方式", trigger: "change" }], // 表单项的验证规则
            props: {
                defaultData: [
                    {
                        "label": "展示广告",
                        "value": "CAMPAIGN_TYPE_DISPLAY"
                    },
                    {
                        "label": "商品广告",
                        "value": "CAMPAIGN_TYPE_SHOPPING",
                        "disabled": true
                    }
                ],
            },
        },
    },

    {
        type: 'ElInput',
        payload: {
            label: "日预算",
            field: "daily_budget",   // 表单项的唯一标识 提交 
            value: '',
            rules: [
                { required: true, message: "请输入计划预算", trigger: "blur" },
                { pattern: /^(?:[5-9][0-9]{2}|[1-9][0-9]{3,8})$/, message: "日预算范围为500-999999999元", trigger: "blur" }
            ], // 表单项的验证规则
            props: {
                placeholder: "请输入计划预算", // 表单项的提示
                clearable: true, // 表单项的清除按钮
                style: "width: 600px", // 表单项的样式
            },
            dependencies: ['range'], // 可以是同级或上级字段
            effects: [
                {
                    condition: {
                        type: 'expression',
                        // 复杂的条件判断
                        expression: "values.range.includes('1')" // "Array.isArray(values.range) && values.range.length > 0"
                    },
                    action: {
                        type: 'setValue',
                        value: '100'
                    }
                },
            ]
            // effects: [
            //     {
            //         // 当field2的值变化时
            //         condition: (values) => values.range == '2',
            //         action: (target) => {
            //             target.formState.payload.value = '100';
            //         }
            //     }
            // ]
        }
    },
    {
        type: 'ElInput',  //'input' |'select' | 'checkbox' | 'radio' | 'WordsInput' | 'WkSelect' | 'WkRadioGroup' | 'WkCheckBoxGroup' | 'DynamicDate'| | 'WkTitle' | 'RadioDesc';
        payload: {
            label: '商品库ID',
            value: '商品ID', // 表单项的值
            field: 'store_id', // 表单项的唯一标识 提交
            rules: [{ required: true, message: '请输入商品ID', trigger: 'change' }], // 表单项的验证规则
            props: {
                placeholder: "请输入计划预算", // 表单项的提示
                clearable: true, // 表单项的清除按钮
                style: "width: 600px", // 表单项的样式
                visible: false, // 表单项的可见性  当前版本不支持 商品库ID
            }
        }
    },
    {
        type: FORM_ITEM_TYPE.WordsInput,  //'
        payload: {
            label: "计划名称",    // 表单项的标题
            value: "{项目名称}-{计划类型}-{版位}-{定向包名称}-{投放策略}-{出价方式}-{转化名称}-{深度转化目标}-{素材类型}-{创建日期}-{任务号-顺序号}-wk",         // 表单项的值
            field: "plan_name",   // 表单项的唯一标识 提交 
            rules: [
                { required: true, message: "请输入计划名称", trigger: "change" },
                { max: 100, message: "计划名称长度不能超过100个字符", trigger: "change" }
            ], // 表单项的验证规则
            props: {
                placeholder: "您可输入或选择通配符动态生成名称，但最终结果名称不可超过60字", // 表单项的提示
                inputStyle: "width: 600px", // 表单项的样式
                defaultData: [
                    {
                        "label": "项目名称",
                        "value": "项目名称"
                    },
                    {
                        "label": "计划类型",
                        "value": "计划类型"
                    },
                    {
                        "label": "版位",
                        "value": "版位"
                    },
                    {
                        "label": "定向包名称",
                        "value": "定向包名称"
                    },
                    {
                        "label": "投放策略",
                        "value": "投放策略"
                    },
                    {
                        "label": "出价方式",
                        "value": "出价方式"
                    },
                    {
                        "label": "转化名称",
                        "value": "转化名称"
                    },
                    {
                        "label": "深度转化目标",
                        "value": "深度转化目标"
                    },
                    {
                        "label": "素材类型",
                        "value": "素材类型"
                    },
                    {
                        "label": "创建日期",
                        "value": "创建日期"
                    },
                    {
                        "label": "任务号-顺序号",
                        "value": "任务号-顺序号"
                    },
                    {
                        "label": "wk",
                        "value": "wk"
                    }
                ]
            },
            onChange: ({ target, newValue }) => {  // 表单项的值改变后的回调函数
                return new Promise((resolve, reject) => {
                    if (newValue && !newValue.includes('任务号-顺序号')) {
                        target.$alert('任务号-顺序号、缺失可能会导致任务创建失败，请检查。', '提示', {
                            confirmButtonText: '确定',
                            type: 'warning',
                            callback: action => {
                                resolve()
                            }
                        });
                    }
                })
            }
        }
    },
    {
        type: 'ElSwitch',  //'input' | 'select' | 'checkbox' | 'radio' | 'WordsInput' | 'WkSelect' | 'WkRadioGroup' | 'WkCheckBoxGroup' | 'DynamicDate'| | 'WkTitle' | 'RadioDesc';
        payload: {
            label: "计划状态",    // 表单项的标题
            value: "2",         // 表单项的值
            field: "plan_status",   // 表单项的唯一标识 提交
            rules: [{ required: true, message: "请选择计划状态", trigger: "change" }], // 表单项的验证规则
            props: {
                activeValue: "1",  // 激活时的值
                inactiveValue: "2", // 非激活时的值
                defaultData: [
                    {
                        "label": "启动",
                        "value": "1"
                    },
                    {
                        "label": "暂停",
                        "value": "2"
                    },
                ]
            },
            dependencies: [],  // 依赖项 
            visibility_conditions: [],
        },
    },
    {
        type: FORM_ITEM_TYPE.WkTitle,
        payload: {
            field: _.uniqueId('title_'),
            props: {
                title: '任务',
            }
        }
    },
    {
        type: 'WkSelect',  //'input' | 'select' | 'checkbox' | 'radio' | 'WordsInput' | 'WkSelect' | 'WkRadioGroup' | 'WkCheckBoxGroup' | 'DynamicDate'| | 'WkTitle' | 'RadioDesc';
        payload: {
            label: "版位选择",    // 表单项的标题
            value: [],         // 表单项的值
            field: "creative_size_id",   // 表单项的唯一标识 提交
            rules: [{ required: true, message: "请选择投放版位", trigger: "change" }], // 表单项的验证规则
            props: {
                filterable: true,
                multiple: true, // 表单项的多选
                placeholder: "请选择投放版位", // 表单项的提示
                style: "width: 600px", // 表单项的样式
                defaultData: [
                    
                 
                ]
            },
            dependencies: [ 'product_type' ],
            effects: [
                {
                    condition: {
                        type: 'expression',
                        expression: 'true'
                    },
                    action: {
                        type: 'function',
                        value: (target) => {
                            const product_type = target.rootFormData.product_type;
                            const list = target.formState.payload.props.defaultData;
                            target.formState.payload.props.defaultData = list.map(v=> {
                                v.disabled = !v.config?.support_product_type?.includes(product_type);
                                return v;
                            });
                        }
                    }
                }
            ]
        },
    },
    
    // {
    //     type: FORM_ITEM_TYPE.WkRadioGroup,  //'input' | 'select' | 'checkbox' | 'radio' | 'WordsInput' | 'WkSelect' | 'WkRadioGroup' | 'WkCheckBoxGroup' | 'DynamicDate'| | 'WkTitle' | 'RadioDesc';
    //     payload: {
    //         label: "推广目的",    // 表单项的标题
    //         value: 'APP_DOWNLOAD',         // 表单项的值
    //         field: "objective_type",   // 表单项的唯一标识 提交
    //         rules: [{ required: true, message: "请选择应用用户", trigger: "change" }], // 表单项的验证规则
    //         props: {
    //             defaultData: [
    //                 {
    //                     "label": "应用下载",
    //                     "value": "APP_DOWNLOAD"
    //                 },
    //                 {
    //                     "label": "应用促活",
    //                     "value": "APP_ACTIVE"
    //                 },
    //                 {
    //                     "label": "应用预约下载",
    //                     "value": "APP_RESERVE_DOWNLOAD",
    //                     "disabled": true
    //                 }
    //             ],
    //         },
    //         dependencies: [],  // 依赖项 
    //         visibility_conditions: [],
    //     },
    // },
    {
        type: 'ElInput',  //
        payload: {
            label: "ROI系数",    // 表单项的标题
            value: "",         // 表单项的值
            field: "roi_ratio",   // 表单项的唯一标识 提交
            rules: [
                { message: "请输入ROI系数", trigger: "blur" },
                { pattern: /^(100|([0-9]\d{0,1})(\.\d{1,4})?)$/, message: "ROI系数上限范围为0-100，可保留四位小数", trigger: "blur" }
            ], // 表单项的验证规则
            props: {
                placeholder: "请输入ROI系数", // 表单项的提示
                clearable: true, // 表单项的清除按钮
                style: "width: 600px", // 表单项的样式
            },
        },
    },
    {
        type: 'ElSwitch',  //'input' | 'select' | 'checkbox' | 'radio' | 'WordsInput' | 'WkSelect' | 'WkRadioGroup' | 'WkCheckBoxGroup' | 'DynamicDate'| | 'WkTitle' | 'RadioDesc';
        payload: {
            label: "智能提价标志",    // 表单项的标题
            value: "DYNAMIC_PRICE_DISABLE",         // 表单项的值
            field: "dyn_price_flag",   // 表单项的唯一标识 提交
            rules: [{ required: true, message: "请选择智能提价标志", trigger: "change" }], // 表单项的验证规则
            props: {
                activeValue: "DYNAMIC_PRICE_ENABLE",  // 激活时的值
                inactiveValue: "DYNAMIC_PRICE_DISABLE", // 非激活时的值
                defaultData: [
                    {
                        "label": "是",
                        "value": "DYNAMIC_PRICE_ENABLE"
                    },
                    {
                        "label": "否",
                        "value": "DYNAMIC_PRICE_DISABLE"
                    }
                ]
            },
            dependencies: [],  // 依赖项 
            visibility_conditions: [],
        },
    },
    {
        type: 'ElInput',  //
        payload: {
            label: "智能提价上限",    // 表单项的标题
            value: "",         // 表单项的值
            field: "dyn_price_upper_limit",   // 表单项的唯一标识 提交
            rules: [
                { pattern: /^(10|([1-9](\.[0-9])?))$/, message: "智能提价上限范围为1-10，可保留一位小数", trigger: "blur" }
            ], // 表单项的验证规则
            props: {
                placeholder: "请输入智能提价上限", // 表单项的提示
                clearable: true, // 表单项的清除按钮
                style: "width: 600px", // 表单项的样式
            },
            dependencies: ["dyn_price_flag"],  // 依赖项 
            effects: [
                {
                    condition: {
                        type: 'expression',
                        expression: "values.dyn_price_flag == 'DYNAMIC_PRICE_ENABLE'"
                    },
                    action: {
                        type: 'setRules',
                        value: [
                            { required: true, message: "请输入智能提价上限", trigger: "blur" },
                            { pattern: /^(10|([1-9](\.[0-9])?))$/, message: "智能提价上限范围为1-10，可保留一位小数", trigger: "blur" }
                        ]
                    }
                },
                {
                    condition: {
                        type: 'expression',
                        expression: "values.dyn_price_flag != 'DYNAMIC_PRICE_ENABLE'"
                    },
                    action: {
                        type: 'setRules',
                        value: [
                            { required: false, message: "请输入智能提价上限", trigger: "blur" },
                            { pattern: /^(10|([1-9](\.[0-9])?))$/, message: "智能提价上限范围为1-10，可保留一位小数", trigger: "blur" }
                        ]
                    }
                },
            ],
        },
    },
    // {
    //     type: FORM_ITEM_TYPE.WkRadioGroup,  //'input' | 'select' | 'checkbox' | 'radio' | 'WordsInput' | 'WkSelect' | 'WkRadioGroup' | 'WkCheckBoxGroup' | 'DynamicDate'| | 'WkTitle' | 'RadioDesc';
    //     payload: {
    //         label: "商品推荐方式",    // 表单项的标题
    //         value: "BEHAVIOR_DATA_RECOMMENDATION",         // 表单项的值
    //         field: "dpa_recommand",   // 表单项的唯一标识 提交
    //         rules: [], // 表单项的验证规则
    //         props: {
    //             defaultData: [
    //                 {
    //                     "label": "行为库推荐",
    //                     "value": "BEHAVIOR_DATA_RECOMMENDATION"
    //                 },
    //                 {
    //                     "label": "LBS推荐",
    //                     "value": "LBS_RECOMMENDATION"
    //                 },
    //             ]
    //         },
    //         dependencies: [],  // 依赖项 
    //         visibility_conditions: [],
    //     },
    // },
    // {
    //     type: FORM_ITEM_TYPE.WkRadioGroup,  //'input' | 'select' | 'checkbox' | 'radio' | 'WordsInput' | 'WkSelect' | 'WkRadioGroup' | 'WkCheckBoxGroup' | 'DynamicDate'| | 'WkTitle' | 'RadioDesc';
    //     payload: {
    //         label: "商品任务过滤条件",    // 表单项的标题
    //         value: false,         // 表单项的值
    //         field: "dpa_filter",   // 表单项的唯一标识 提交
    //         rules: [], // 表单项的验证规则
    //         props: {
    //             defaultData: [
    //                 {
    //                     "label": "商店-搜索",
    //                     "value": "20"
    //                 },
    //                 {
    //                     "label": "商店-富媒体",
    //                     "value": "34"
    //                 },
    //             ]
    //         },
    //         dependencies: [],  // 依赖项 
    //         visibility_conditions: [],
    //     },
    // },
    {
        type: 'ElInput',  //'input' | 'select' | 'checkbox' | 'radio' | 'WordsInput' | 'WkSelect' | 'WkRadioGroup' | 'WkCheckBoxGroup' | 'DynamicDate'| | 'WkTitle' | 'RadioDesc';
        payload: {
            label: "多日频控N天M次中的N",    // 表单项的标题
            value: '',         // 表单项的值
            field: "fc_days",   // 表单项的唯一标识 提交
            rules: [
                { required: false, message: "请输入多日频控N天M次中的N", trigger: "blur" },
                { pattern: /^[1-5]$/, message: "N范围为1-5", trigger: "blur" }
            ], // 表单项的验证规则
            props: {
                placeholder: "多日频控N天M次中的N", // 表单项的提示
                clearable: true, // 表单项的清除按钮
                style: "width: 600px", // 表单项的样式
            },
            dependencies: [],  // 依赖项 time_period
            visibility_conditions: [],
        },
    },
    {
        type: 'ElInput',  //'input' | 'select' | 'checkbox' | 'radio' | 'WordsInput' | 'WkSelect' | 'WkRadioGroup' | 'WkCheckBoxGroup' | 'DynamicDate'| | 'WkTitle' | 'RadioDesc';
        payload: {
            label: "多日频控N天M次中的M",    // 表单项的标题
            value: '',         // 表单项的值
            field: "fc_upper_times",   // 表单项的唯一标识 提交
            rules: [
                { required: false, message: "请输入多日频控N天M次中的M", trigger: "blur" },
                { pattern: /^(10|[1-9])$/, message: "M范围为1-10", trigger: "blur" }
            ], // 表单项的验证规则
            props: {
                placeholder: "多日频控N天M次中的M", // 表单项的提示
                clearable: true, // 表单项的清除按钮
                style: "width: 600px", // 表单项的样式
            },
            dependencies: [],  // 依赖项 
            visibility_conditions: [],
        },
    },
    {
        type: FORM_ITEM_TYPE.DynamicDate,  //'input' | 'select' | 'checkbox' | 'radio' | 'WordsInput' | 'WkSelect' | 'WkRadioGroup' | 'WkCheckBoxGroup' | 'DynamicDate'| | 'WkTitle' | 'RadioDesc';
        payload: {
            label: "投放日期",    // 表单项的标题
            value: [2, '', ''],         // 表单项的值
            field: "date",   // 表单项的唯一标识 提交
            rules: [{ required: true, message: "请选择投放日期", trigger: "change" }], // 表单项的验证规则
            props: {},
            dependencies: [],  // 依赖项 
            visibility_conditions: [],
        },
    },
    {
        type: FORM_ITEM_TYPE.WkRadioGroup,  //'input' | 'select' | 'checkbox' | 'radio' | 'WordsInput' | 'WkSelect' | 'WkRadioGroup' | 'WkCheckBoxGroup' | 'DynamicDate'| | 'WkTitle' | 'RadioDesc';
        payload: {
            label: "投放时间",    // 表单项的标题
            value: "TIME_PERIOD_ALL",         // 表单项的值
            field: "time_period_type",   // 表单项的唯一标识 提交
            rules: [{ required: true, message: "请选择投放日期", trigger: "change" }], // 表单项的验证规则
            props: {
                defaultData: []
            },
            dependencies: [],  // 依赖项 
        },
    },
    {
        type: FORM_ITEM_TYPE.WkRangFixedTime,  //'input' | 'select' | 'checkbox' | 'radio' | 'WordsInput' | 'WkSelect' | 'WkRadioGroup' | 'WkCheckBoxGroup' | 'DynamicDate'| | 'WkTitle' | 'RadioDesc';
        payload: {
            label: "特定时间段",    // 表单项的标题
            value: ['01:00', '23:00'],         // 表单项的值
            field: "times_fixed",   // 表单项的唯一标识 提交
            rules: [
                { required: true, message: "请选择投放日期", trigger: "change" },
                { validator: (rule, value, callback) => {
                    if (value.some(v=>v.indexOf(':00') === -1)) {
                        callback(new Error('不支持分时时段，请重新选择'));
                    } else {
                        callback();
                    }
                }, trigger: "change" }
            ], // 表单项的验证规则
            props: {
                visible: false,
                pickerOptions: {
                    start: '00:00',
                    step: '01:00',
                    end: '24:00'
                }
            },
            dependencies: ["time_period_type"],  // 依赖项 
            effects: [
                {
                    condition: {
                        type: 'expression',
                        expression: "values.time_period_type == 'TIME_PERIOD_DAY_SPECIFIC'"
                    },
                    action: {
                        type: 'setVisible',
                        value: true
                    }
                },
                {
                    condition: {
                        type: 'expression',
                        expression: "values.time_period_type != 'TIME_PERIOD_DAY_SPECIFIC'"
                    },
                    action: {
                        type: 'setVisible',
                        value: false
                    }
                }
            ],
            visibility_conditions: [],
        },
    },
    {
        type: FORM_ITEM_TYPE.WkDropTime,  //'input' | 'select' | 'checkbox' | 'radio' | 'WordsInput' | 'WkSelect' | 'WkRadioGroup' | 'WkCheckBoxGroup' | 'DynamicDate'| | 'WkTitle' | 'RadioDesc';
        payload: {
            label: "多个时间段",    // 表单项的标题
            value: '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000',         // 表单项的值
            field: "times_drop",   // 表单项的唯一标识 提交
            rules: [{ required: true, message: "请选择投放日期", trigger: "change" }], // 表单项的验证规则
            props: {
                visible: false,
            },
            dependencies: ["time_period_type"],  // 依赖项 
            effects: [
                {
                    condition: {
                        type: 'expression',
                        expression: "values.time_period_type == 'TIME_PERIOD_HOUR_SPECIFIC'"
                    },
                    action: {
                        type: 'setVisible',
                        value: true
                    }
                },
                {
                    condition: {
                        type: 'expression',
                        expression: "values.time_period_type != 'TIME_PERIOD_HOUR_SPECIFIC'"
                    },
                    action: {
                        type: 'setVisible',
                        value: false
                    }
                },

            ],
        },
    },
    {
        type: FORM_ITEM_TYPE.WordsInput,  //'
        payload: {
            label: "广告组名称",    // 表单项的标题
            value: "{项目名称}-{版位}-{投放策略}-{出价方式}-{转化名称}-{深度转化目标}-{素材类型}-{创建日期}-{任务号-顺序号}-wk",         // 表单项的值
            field: "adgroup_name",   // 表单项的唯一标识 提交 
            rules: [
                { required: true, message: "请输入广告组名称", trigger: "change" },
                { max: 100, message: "广告组名称长度不能超过100个字符", trigger: "change" }
            ], // 表单项的验证规则
            props: {
                placeholder: "您可输入或选择通配符动态生成名称，但最终结果名称不可超过60字", // 表单项的提示
                inputStyle: "width: 600px", // 表单项的样式
                defaultData: [
                    {
                        "label": "项目名称",
                        "value": "项目名称"
                    },
                    {
                        "label": "版位",
                        "value": "版位"
                    },
                    {
                        "label": "定向包名称",
                        "value": "定向包名称"
                    },
                    {
                        "label": "投放策略",
                        "value": "投放策略"
                    },
                    {
                        "label": "出价方式",
                        "value": "出价方式"
                    },
                    {
                        "label": "转化名称",
                        "value": "转化名称"
                    },
                    {
                        "label": "深度转化目标",
                        "value": "深度转化目标"
                    },
                    {
                        "label": "素材类型",
                        "value": "素材类型"
                    },
                    {
                        "label": "创建日期",
                        "value": "创建日期"
                    },
                    {
                        "label": "任务号-顺序号",
                        "value": "任务号-顺序号"
                    },
                    {
                        "label": "wk",
                        "value": "wk"
                    }
                ]
            },
            // onChange: ({ target, newValue }) => {  // 表单项的值改变后的回调函数
            //     let ele_adgroup_name = document.querySelector('input[field="adgroup_name"]')
            //     if(ele_adgroup_name) {
            //         // 先移除已有的监听器
            //         ele_adgroup_name.removeEventListener('blur', ele_adgroup_name._blurHandler)

            //         // 创建新的监听器
            //         ele_adgroup_name._blurHandler = () => {
            //             if(!newValue) {
            //                 return
            //             }
            //             let plan_allocation_rules_label = target.rootFormDataOptions?.plan_allocation_rules.filter(item => target.rootFormData?.plan_allocation_rules.includes(item.value) && item.value != 'element_group').map(item => {
            //                 if(item.value == 'app') {
            //                     return '项目名称'
            //                 }else if(item.value == 'target') { 
            //                     return '定向包名称'
            //                 }else {
            //                     return item.label
            //                 }
            //             })
            //             let isEvery = plan_allocation_rules_label.every(item => newValue.includes(item))
            //             if (!isEvery) {
            //                 target.$alert('计划分配规则与计划名称通配符不匹配，可能会导致计划名称过长，请检查。', '提示', {
            //                     confirmButtonText: '确定',
            //                     type: 'warning'
            //                 });
            //             }
            //         }

            //         // 添加新的监听器
            //         ele_adgroup_name.addEventListener('blur', ele_adgroup_name._blurHandler)
            //     }
            // }
        }
    },
    {
        type: 'ElSwitch',  //'input' | 'select' | 'checkbox' | 'radio' | 'WordsInput' | 'WkSelect' | 'WkRadioGroup' | 'WkCheckBoxGroup' | 'DynamicDate'| | 'WkTitle' | 'RadioDesc';
        payload: {
            label: "广告组状态",    // 表单项的标题
            value: "2",         // 表单项的值
            field: "adgroup_status",   // 表单项的唯一标识 提交
            rules: [{ required: true, message: "请选择广告组状态", trigger: "change" }], // 表单项的验证规则
            props: {
                activeValue: "1",  // 激活时的值
                inactiveValue: "2", // 非激活时的值
                defaultData: [
                    {
                        "label": "启动",
                        "value": "1"
                    },
                    {
                        "label": "暂停",
                        "value": "2"
                    },
                ]
            },
            dependencies: [],  // 依赖项 
            visibility_conditions: [],
        },
    },
    {
        type: FORM_ITEM_TYPE.WkTitle,
        payload: {
            field: _.uniqueId('title_'),
            props: {
                title: '创意',
            }
        }
    },
    {
        type: FORM_ITEM_TYPE.WordsInput,  //'
        payload: {
            label: "创意名称",    // 表单项的标题
            value: "{项目名称}-{版位}-{定向包名称}-{投放策略}-{出价方式}-{转化名称}-{深度转化目标}-{素材类型}-{创建日期}-{任务号-顺序号}-wk",         // 表单项的值
            field: "creative_name",   // 表单项的唯一标识 提交 
            rules: [
                { required: true, message: "请输入创意名称", trigger: "change" },
                { max: 100, message: "创意名称长度不能超过100个字符", trigger: "change" }
            ], // 表单项的验证规则
            props: {
                placeholder: "您可输入或选择通配符动态生成名称，但最终结果名称不可超过60字", // 表单项的提示
                inputStyle: "width: 600px", // 表单项的样式
                defaultData: [
                    {
                        "label": "项目名称",
                        "value": "项目名称"
                    },
                    {
                        "label": "版位",
                        "value": "版位"
                    },
                    {
                        "label": "定向包名称",
                        "value": "定向包名称"
                    },
                    {
                        "label": "投放策略",
                        "value": "投放策略"
                    },
                    {
                        "label": "出价方式",
                        "value": "出价方式"
                    },
                    {
                        "label": "转化名称",
                        "value": "转化名称"
                    },
                    {
                        "label": "深度转化目标",
                        "value": "深度转化目标"
                    },
                    {
                        "label": "素材类型",
                        "value": "素材类型"
                    },
                    {
                        "label": "创建日期",
                        "value": "创建日期"
                    },
                    {
                        "label": "任务号-顺序号",
                        "value": "任务号-顺序号"
                    },
                    {
                        "label": "wk",
                        "value": "wk"
                    }
                ]
            },
        }
    },
    {
        type: 'ElSwitch',  //'input' | 'select' | 'checkbox' | 'radio' | 'WordsInput' | 'WkSelect' | 'WkRadioGroup' | 'WkCheckBoxGroup' | 'DynamicDate'| | 'WkTitle' | 'RadioDesc';
        payload: {
            label: "创意状态",    // 表单项的标题
            value: "2",         // 表单项的值
            field: "creative_status",   // 表单项的唯一标识 提交
            rules: [{ required: true, message: "请选择广告组状态", trigger: "change" }], // 表单项的验证规则
            props: {
                activeValue: "1",  // 激活时的值
                inactiveValue: "2", // 非激活时的值
                defaultData: [
                    {
                        "label": "启动",
                        "value": "1"
                    },
                    {
                        "label": "暂停",
                        "value": "2"
                    },
                ]
            },
            dependencies: [],  // 依赖项 
            visibility_conditions: [],
        },
    },
    {
        type: FORM_ITEM_TYPE.WkSelect,
        payload: {
            label: "按钮文案",
            value: "",
            field: "selected_text_id",
            props: {
                filterable: true,
                clearable: true,
                placeholder: "请选择按钮文案",
                style: "width: 600px",
                defaultData: []
            }
        }
    },
    {
        type: FORM_ITEM_TYPE.WkTitle,
        payload: {
            field: _.uniqueId('title_'),
            props: {
                title: '分配规则',
            }
        }
    },
    {
        type: FORM_ITEM_TYPE.WkCheckBoxGroup,  //'input' | 'select' | 'checkbox' | 'radio' | 'WordsInput' | 'WkSelect' | 'WkRadioGroup' | 'WkCheckBoxGroup' | 'DynamicDate'| | 'WkTitle' | 'RadioDesc';
        payload: {
            label: "计划分配规则",    // 表单项的标题
            value: ['app'],         // 表单项的值
            field: "plan_allocation_rules",   // 表单项的唯一标识 提交
            labelTip: '按照选择的选项与实际配置的内容，每一种不同的组合将创建一个新的计划。当计划与任务分配规则选择一致时，表示一个计划下一个任务。如：选择了应用与定向，选择了2个应用，上传了2个定向包，则为2*2=4个计划。',  // 表单项的提示
            rules: [{ required: true, message: "请选择计划分配规则", trigger: "change" }], // 表单项的验证规则
            props: {
                defaultData: [
                    {
                        "label": "产品",
                        "value": "app",
                    },
                    {
                        "label": "版位",
                        "value": "display_type",
                    },
                    {
                        "label": "定向",
                        "value": "target",
                    },
                    {
                        "label": "投放策略",
                        "value": "ocpc_strategy"
                    },
                    {
                        "label": "出价方式",
                        "value": "price_type"
                    },
                    {
                        "label": "转化名称",
                        "value": "effect_name"
                    },
                    {
                        "label": "深度转化目标",
                        "value": "deep_effect_target"
                    },
                    {
                        "label": "素材类型",
                        "value": "material_type"
                    },
                    {
                        "label": "元素组",
                        "value": "element_group"
                    }
                ],
            },
            onChange: ({ target, newValue, oldValue }) => {  // 表单项的值改变后的回调函数
                if (!target.rootFormData.adgroup_name || target.rootFormData.adgroup_name.length == 0) {
                    return
                }
                const getRuleLabel = (item) => {
                    const labelMap = {
                        'app': '项目名称',
                        'target': '定向包名称'
                    };
                    return labelMap[item.value] || item.label;
                };

                const rules = target.rootFormDataOptions?.plan_allocation_rules
                    .filter(item => item.value !== 'element_group');

                if(newValue.length < oldValue.length) {
                    const channel_item = _.without(oldValue, ...newValue);
                    // const plan_allocation_rules_list = rules.map(getRuleLabel);
                    const plan_allocation_rules_label = rules
                        .filter(item => channel_item.includes(item.value))
                        .map(getRuleLabel);
                    // const without = _.without(plan_allocation_rules_list, ...plan_allocation_rules_label);
                    const isEvery = plan_allocation_rules_label.some(item => target.rootFormData.adgroup_name.includes(item));
                    if (isEvery) {
                        return new Promise((resolve) => {
                            target.$alert('计划分配规则与计划名称通配符不匹配，可能会导致计划名称过长，请检查。', '提示', {
                                confirmButtonText: '确定',
                                type: 'warning',
                                callback: () => resolve()
                            });
                        });
                    }
                    return
                }
            },
            dependencies: ['adgroup_allocation_rules'],  // 依赖项 
            effects: [
                {
                    condition: {
                        type: 'expression',
                        expression: '!values.adgroup_allocation_rules.includes("material_type") || !values.adgroup_allocation_rules.includes("element_group")'
                    },
                    action: {
                        type: 'function',
                        value: (target) => {
                            let value = []
                            let plan_allocation_rules_values = target.rootFormData.plan_allocation_rules
                            if (!target.rootFormData.adgroup_allocation_rules.includes('material_type')) {
                                value = _.without(plan_allocation_rules_values, 'material_type')
                                plan_allocation_rules_values = value
                            }
                            if (!target.rootFormData.adgroup_allocation_rules.includes('element_group')) {
                                value = _.without(plan_allocation_rules_values, 'element_group')
                            }
                            let uniq_value = _.uniq(value)
                            Vue.set(target.formState.payload, 'value', uniq_value);
                        }
                    }
                }
            ]
        },
    },
    {
        type: FORM_ITEM_TYPE.WkCheckBoxGroup,  //'input' | 'select' | 'checkbox' | 'radio' | 'WordsInput' | 'WkSelect' | 'WkRadioGroup' | 'WkCheckBoxGroup' | 'DynamicDate'| | 'WkTitle' | 'RadioDesc';
        payload: {
            label: "任务分配规则",    // 表单项的标题
            value: ['app', 'display_type', 'target', 'ocpc_strategy', 'price_type', 'effect_name', 'deep_effect_target'],         // 表单项的值
            field: "adgroup_allocation_rules",   // 表单项的唯一标识 提交
            labelTip: "按照选择的选项与实际配置的内容，每一种不同的组合将创建一个新的任务。当计划与任务分配规则选择一致时，表示一个计划下一个任务。如：选择了应用与定向，选择了2个应用，上传了2个定向包，则为2*2=4个任务。",
            rules: [{ required: true, message: "请选择应用用户", trigger: "change" }], // 表单项的验证规则
            props: {
                defaultData: [
                    {
                        "label": "产品",
                        "value": "app",
                        disabled: true
                    },
                    {
                        "label": "版位",
                        "value": "display_type",
                        disabled: true
                    },
                    {
                        "label": "定向",
                        "value": "target",
                        disabled: true
                    },
                    {
                        "label": "投放策略",
                        "value": "ocpc_strategy",
                        disabled: true
                    },
                    {
                        "label": "出价方式",
                        "value": "price_type",
                        disabled: true
                    },
                    {
                        "label": "转化名称",
                        "value": "effect_name",
                        disabled: true
                    },
                    {
                        "label": "深度转化目标",
                        "value": "deep_effect_target",
                        disabled: true
                    },
                    {
                        "label": "素材类型",
                        "value": "material_type"
                    },
                    {
                        "label": "元素组",
                        "value": "element_group"
                    }
                ],
            },
            dependencies: ['plan_allocation_rules'],  // 依赖项 
            effects: [
                {
                    condition: {
                        type: 'expression',
                        expression: 'values.plan_allocation_rules.includes("material_type") || values.plan_allocation_rules.includes("element_group")'
                    },
                    action: {
                        type: 'function',
                        value: (target) => {
                            let result = []
                            if (target.rootFormData.plan_allocation_rules.includes('material_type')) {
                                result.push('material_type')
                            }
                            if (target.rootFormData.plan_allocation_rules.includes('element_group')) {
                                result.push('element_group')
                            }
                            let value = _.uniq([...target.rootFormData.adgroup_allocation_rules, ...result])
                            Vue.set(target.formState.payload, 'value', value);
                        }
                    }
                }
            ]
        },
    },
    {
        type: FORM_ITEM_TYPE.WkRadioGroup,  //'input' | 'select' | 'checkbox' | 'radio' | 'WordsInput' | 'WkSelect' | 'WkRadioGroup' | 'WkCheckBoxGroup' | 'DynamicDate'| | 'WkTitle' | 'RadioDesc';
        payload: {
            label: "元素组分配规则",    // 表单项的标题
            value: '2',         // 表单项的值
            field: "element_group_allocation_rules",   // 表单项的唯一标识 提交
            labelTip: "按照选择的选项与上传的创意，决定创建多少个元素组，以及每个元素组内放置哪些素材。\n素材类型：按照素材类型（图片/视频）分为不同的元素组，但每个元素组最多不超过10个图片或5个视频，超过时创建新的元素组。\n单素材：每个素材1个元素组，既上传了多少素材，就有多少个元素组。（需要封面的视频，封面+视频为1个素材）。\n满配：10个图片+5个视频为1个元素组，超出时创建新的元素组。",
            rules: [{ required: true, message: "请选择应用用户", trigger: "change" }], // 表单项的验证规则
            props: {
                defaultData: [
                    {
                        "label": "素材类型",
                        "value": "1",
                        "disabled": true
                    },
                    {
                        "label": "单素材",
                        "value": "2",
                    },
                    {
                        "label": "满配（10图+5视频）",
                        "value": "3",
                        "disabled": true
                    },
                ],
            },
            dependencies: [],  // 依赖项 
            visibility_conditions: [],
        },
    },
    {
        type: FORM_ITEM_TYPE.WkTitle,
        payload: {
            field: _.uniqueId('title_'),
            props: {
                title: '分产品配置',
            }
        }
    },
    {
        type: FORM_ITEM_TYPE.WkButton,
        payload: {
            field: 'product_config_list',
            label: "分产品配置侧边栏",
            labelTip: "为每个产品配置独有的选项内容，该产品的计划、任务、创意将使用分别维护的信息进行创建。",
            rules: [{ required: true, type: 'array', message: "分产品配置不可为空", trigger: "change" }],
            value: [],
            props: {
                defaultData: "分产品配置侧边栏",
                type: "primary",
                // fn: (params) => (productConfigDrawer({ props: { visible: true, ...params } }))
            },
        }
    },
    {
        type: FORM_ITEM_TYPE.WkTitle,
        payload: {
            field: _.uniqueId('title_'),
            props: {
                title: '叉乘元素',
            }
        }
    },
    {
        type: FORM_ITEM_TYPE.WkBlockText,
        payload: {
            field: _.uniqueId('title_'),
            props: {
                text: '叉乘条件:不同应用定向包 × 不同应用、版位的转化出价分别 × 不同应用、版位的创意组 = 广告创意数量',
            }
        }
    },
    {
        type: FORM_ITEM_TYPE.WkModalForm,
        payload: {
            field: 'modalForm',
            value: [null, null, null, {}],
            props: {

            }
        }
    }
]

